export default {"src":"/_next/static/media/menu-icon.a67b92f4.svg","height":100,"width":100,"blurWidth":0,"blurHeight":0};